<div class="alert-dialog-container">
  <div class="content">
    <div class="headline">
      {{ data.headline }}
    </div>
    <div class="body">
     {{ data.body }}
    </div>
    <div class="actions">
      <div class="cancel">
        <kion-button mode="discreet" [title]="data.btnCancel" (clicked)="submit(false)"></kion-button>
      </div>
     <div class="submit">
       <kion-button mode="primary" [title]="data.btnSubmit" (clicked)="submit(true)"></kion-button>
     </div>
    </div>
  </div>
</div>
